import { CommonModule } from "@angular/common";
import { Component, Input, inject } from "@angular/core";
import { ForgeIconModule } from "@tylertech/forge-angular";
import { IntentService } from "@tylertech/intents-module";
import { IProcessStep } from "@tylertech/tyler-api-types";
@Component({
    selector: "process-step",
    imports: [
        CommonModule,
        ForgeIconModule,
    ],
    templateUrl: "./processStep.tmpl.html",
})
export class ProcessStepComponent
{
    private $intentService = inject(IntentService);

    @Input()
    entity: IProcessStep;

    @Input()
    enableLink: boolean;

    @Input()
    isProcessing: boolean = false;

    get complete(): boolean
    {
        return this.entity.Complete;
    }

    get locked(): boolean
    {
        return this.entity.Locked;
    }

    get showComplete(): boolean
    {
        return this.complete;
    }

    get showLocked(): boolean
    {
        return !this.complete && this.locked;
    }

    get showReady(): boolean
    {
        return !this.complete && !this.locked;
    }

    get className(): string
    {
        return this.showReady && this.enableLink ? "no-focus" : "no-focus no-pointer";
    }

    openStep(): void
    {
        if (this.showReady && this.enableLink)
        {
            this.showProgressCircular();
            setTimeout(() =>
            {
                this.$intentService.resolve("ProcessStep", "View", {
                    ProcessId: this.entity.ProcessId,
                    StepId: this.entity.StepId,
                });
                this.hideProgress();
            }, 1000);
        }
    }

    private showProgressCircular(): void
    {
        this.isProcessing = true;
    }

    private hideProgressCircular(): void
    {
        this.isProcessing = false;
    }

    hideProgress(): void
    {
        setTimeout(() =>
        {
            this.hideProgressCircular();
        }, 250);
    }
}
